import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentLayoutComponent } from './shared/layout-components/layout/content-layout/content-layout.component';
import { content } from './shared/routes/routes copy';
import { FormComponent } from './components/prospect/form/form.component';
import { environment } from '../environments/environment';

const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./components/components.module').then((m) => m.ConponentsModule),
  },
  {
    path: 'dashboard/home',
    pathMatch: 'full',
    redirectTo: environment.isShowNewScreen ? '/dashboard/home' : '/reports',
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: content,
  },
  {
    path: 'prospect-form',
    component: FormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
